import React, { useState } from 'react';
import { useTranslations } from 'next-intl';
import { ResponsiveMenuStore } from '@/store/sideSheet.js';
import { NotificationsSwitchSection } from '@desquared/wave-components-library';
import User from '@/store/user.js';
import { updateUserConsents } from '@/api/users.js';
import Cookies from 'universal-cookie';
import { useConfiguration } from '@/contexts/ConfigContext.jsx';

export default function NotificationsPage() {
  const t = useTranslations('user_notifications');
  const r = useTranslations('account_details');
  const cookies = new Cookies();
  const { config } = useConfiguration();

  const [wantsNotifications, setWantsNotifications] = useState(User.getValue()?.receiveNewsletters);
  const authorization = cookies.get('authorization');

  const handleToggle = async value => {
    try {
      const res = await updateUserConsents(authorization, {
        newsletter: value,
        chatbot: config?.services?.chatbot?.enabled ?? false,
      });

      if (res.status === 200) {
        const userConsents = {
          receiveNewsletters: res.data.receiveNewsletters,
          receiveChatbotMessages: res.data.receiveChatbotMessages,
          customerServiceIntegratorId: res.data.customerServiceIntegratorId,
        };

        User.update(userConsents);
      }
      setWantsNotifications(value);
    } catch (err) {
      console.error('Error updating notifications:', err);
      // rollback if needed
      setWantsNotifications(prev => !prev);
    }
  };

  const openMenu = () => {
    ResponsiveMenuStore.open();
  };

  return (
    <>
      <NotificationsSwitchSection
        title={t('title')}
        switchTitle={t('switch_title')}
        switchSubtitle={r('accept_notifications')}
        wantsNotifications={wantsNotifications}
        setWantsNotifications={handleToggle}
        onBack={openMenu}
      />
    </>
  );
}
